// import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';

import { Button, FormHelperText, IconButton, InputAdornment, TextField, MobileStepper, Typography } from '@mui/material';
import { MuiTelInput } from 'mui-tel-input';
import { useTheme } from '@mui/styles';

import { postUrl } from '@utils/ApiAction';
// import COUNTRIES from '@utils/CountryList';
import useNotificationLoading from '@utils/useNotificationLoading';

import { FiEye, FiEyeOff, FiLock, FiMail, FiUser, FiGlobe, FiChevronDown, FiChevronLeft, FiChevronRight } from 'react-icons/fi';
import { FaPhoneAlt } from "react-icons/fa";


import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';

// import CustomSelect from '@components/CustomSelect';

export default function RegisterForm(props) {
    const { setSuccess, url } = props;
    const theme = useTheme();
    const { t, i18n } = useTranslation();
    const { addAlert, setLoading } = useNotificationLoading();
    const [inputErrors, setInputErrors] = useState({});
    const [searchParams] = useSearchParams();
    const { username } = useSelector(state => state.user);

    const [state, setState] = useState({
        // username: username?username:'',
        username: '',
        name: '',
        email: '',
        fullMobile: '',
        mobileCountryCode: '',
        mobile: '',
        country: '',
        password: '',
        passwordConfirmation: '',
        securityPassword: '',
        securityPasswordConfirmation: '',
        referralName: searchParams.get('referral') ? searchParams.get('referral') : username ? username : '',
        // placementName: '',
        // placementPosition: 1,
    });

    const [option, setOption] = useState({
        passwordShow: false,
        passwordConfirmationShow: false,
        securityPasswordShow: false,
        securityPasswordConfirmationShow: false
    });
    // const POSITION = [
    //     { 'code': 'left', 'value': 1, label: t('general.left') },
    //     { 'code': 'right', 'value': 2, label: t('general.right') }
    // ];

    const handleChange = ({ target }) => {
        let { name, value } = target;
        if (name === 'mobile') {
            value = !/^\s*$/.test(value) && !isNaN(value) ? value : "";
        }
        setState({ ...state, [name]: value });
    };

    const handleChangeMobile = (value, info) => {
        setState({ 
            ...state, 
            fullMobile: (value || info?.numberValue), 
            mobileCountryCode: info?.countryCallingCode ? `+${info?.countryCallingCode}` : '', 
            country: info?.countryCode, 
            mobile: info?.nationalNumber 
        });
    };

    const handlePasswordShow = (name) => {
        setOption({ ...option, [name]: !option[name] });
    }

    const handleSubmit = () => {
        setLoading(true);
        setInputErrors({});
        let params = {
            name: state.name,
            username: state.username,
            email: state.email,
            mobile_country_code: state.mobileCountryCode,
            mobile: state.mobile,
            country: state.country,
            password: state.password,
            password_confirmation: state.passwordConfirmation,
            security_password: state.securityPassword,
            security_password_confirmation: state.securityPasswordConfirmation,
            referral_name: state.referralName,
            // placement_name: state.placementName,
            // placement_position: state.placementPosition
        }

        postUrl(url ? url : '/register', params).then(response => {
            setLoading(false);
            if (response.status) {
                if (setSuccess) setSuccess(true);
                setState({
                    username: '',
                    name: '',
                    email: '',
                    fullMobile: '',
                    mobileCountryCode: '',
                    mobile: '',
                    country: '',
                    password: '',
                    passwordConfirmation: '',
                    securityPassword: '',
                    securityPasswordConfirmation: '',
                    referralName: searchParams.get('referral') ? searchParams.get('referral') : username ? username : '',
                    // placementName: '',
                    // placementPosition: 1,
                });
                addAlert('', response.message, 'success', '');
            } else {
                setInputErrors(response.errors);
                addAlert('', response.message, 'error', '');
            }
        }).catch((error) => {
            setLoading(false);
            addAlert('', error.message || t('error.contactSupport'), 'error', '');
        });
    }

    let currLanguage = 'us';
    switch(i18n.language) {
        case 'cn':
            currLanguage = 'zh';
            break;
        default:
            currLanguage = 'us';
            break;
    }

    const [activeStep, setActiveStep] = React.useState(0);
  
    const handleNext = () => {
        setLoading(true);
        setInputErrors({});
        let params = {
            name: state.name,
            username: state.username,
            email: state.email,
            mobile_country_code: state.mobileCountryCode,
            mobile: state.mobile,
            country: state.country,
            password: state.password,
            password_confirmation: state.passwordConfirmation,
            security_password: state.securityPassword,
            security_password_confirmation: state.securityPasswordConfirmation,
            referral_name: state.referralName,
            step: activeStep
        }

        postUrl( '/register-check', params).then(response => {
            setLoading(false);
            if (response.status) {
                setActiveStep((prevActiveStep) => prevActiveStep + 1);
            } else {
                setInputErrors(response.errors);
                addAlert('', response.message, 'error', '');
            }
        }).catch((error) => {
            setLoading(false);
            addAlert('', error.message || t('error.contactSupport'), 'error', '');
        });
    };
  
    const handleBack = () => {
        setLoading(true);
        setInputErrors({});
        let params = {
            name: state.name,
            username: state.username,
            email: state.email,
            mobile_country_code: state.mobileCountryCode,
            mobile: state.mobile,
            country: state.country,
            password: state.password,
            password_confirmation: state.passwordConfirmation,
            security_password: state.securityPassword,
            security_password_confirmation: state.securityPasswordConfirmation,
            referral_name: state.referralName,
            step: activeStep
        }

        postUrl( '/register-check', params).then(response => {
            setLoading(false);
            if (response.status) {
                setActiveStep((prevActiveStep) => prevActiveStep - 1);
            } else {
                setInputErrors(response.errors);
            }
        }).catch((error) => {
            setLoading(false);
            addAlert('', error.message || t('error.contactSupport'), 'error', '');
        });
      
    };

    const stepOne = () =>{
        return (
            <div>
                <div className='p-t-20 w-full flex-col-m' style={{ gap: 15 }}>
                    <div>
                        <p className='cl-label fs-14'>{t('user.name')}</p>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name='name'
                            onChange={handleChange}
                            helperText={inputErrors && inputErrors.name ? inputErrors.name : ''}
                            error={inputErrors && inputErrors.name ? true : false}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                disableUnderline: true,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiUser className="img-style fs-18 " />
                                    </InputAdornment>
                                ),
                            }}
                            value={state?.name}
                        />
                    </div>
                    <div>
                        <p className='cl-label fs-14'>{t('user.username')}</p>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name='username'
                            onChange={handleChange}
                            helperText={inputErrors && inputErrors.username ? inputErrors.username : ''}
                            error={inputErrors && inputErrors.username ? true : false}
                            InputLabelProps={{ shrink: true }}
                            value={state?.username}
                            InputProps={{
                                disableUnderline: true,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiUser className="img-style fs-18" />
                                    </InputAdornment>
                                ),
                            }}
                        />
                    </div>
                    <div>
                        <p className='cl-label fs-14'>{t('user.email')}</p>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name='email'
                            onChange={handleChange}
                            required
                            helperText={inputErrors && inputErrors.email ? inputErrors.email : ''}
                            error={inputErrors && inputErrors.email ? true : false}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                disableUnderline: true,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiMail className="img-style fs-18" />
                                    </InputAdornment>
                                ),
                            }}
                            value={state?.email}
                        />
                    </div>

                    <div>
                        <p className='cl-label fs-14'>{t('user.mobile')}</p>
                        <MuiTelInput
                            fullWidth
                            variant="outlined"
                            name='mobile'
                            value={state?.fullMobile || ''}
                            onChange={handleChangeMobile}
                            langOfCountryName={currLanguage}
                            unknownFlagElement={
                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                    <div style={{ position: 'relative' }}>
                                        <FiGlobe size={18} />
                                        <FaPhoneAlt size={14} style={{ position: 'absolute', left: -4, bottom: 1 }} />
                                    </div>
                                    <FiChevronDown size={15} />
                                </div>
                            }
                            focusOnSelectCountry
                            helperText={
                                <>
                                    {inputErrors?.mobile_country_code && (<div>{inputErrors.mobile_country_code}</div>)}
                                    {inputErrors?.mobile && (<div>{inputErrors.mobile}</div>)}
                                </>}
                            error={inputErrors && (inputErrors.mobile_country_code || inputErrors?.mobile) ? true : false}
                        />
                    </div>

                    <div>
                        <p className='cl-label fs-14'>{t('user.referralName')}</p>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name='referralName'
                            onChange={handleChange}
                            helperText={inputErrors && inputErrors.referral_name ? inputErrors.referral_name : ''}
                            error={inputErrors && inputErrors.referral_name ? true : false}
                            InputLabelProps={{ shrink: true }}
                            InputProps={{
                                disableUnderline: true,
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiUser className="img-style fs-18" />
                                    </InputAdornment>
                                ),
                                readOnly: searchParams.get("referral") ? true : false,
                            }}
                            value={state?.referralName}
                        />
                    </div>
                </div>
                <div className='p-t-20'>
                    <Button type="button" className='translateY' variant="contained" onClick={handleNext} fullWidth >{t('button.nextStep')}</Button>
                </div>
            </div>
        )
    }

    const stepTwo = () =>{
        return (
            <div>
                <div className='p-t-20 w-full flex-col-m' style={{ gap: 15 }}>
                    <div>
                        <p className='cl-label fs-14'>{t('user.password')}</p>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name='password'
                            onChange={handleChange}
                            type={option?.passwordShow ? 'text' : 'password'}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiLock className="img-style fs-18" />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => handlePasswordShow('passwordShow')}>
                                            {option?.passwordShow ? <FiEye className="img-style" style={{ color: theme.palette.inputIconColor }} /> : <FiEyeOff className="img-style" style={{ color: theme.palette.inputIconColor }} />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                disableUnderline: true
                            }}
                            helperText={inputErrors && inputErrors.password ? inputErrors.password : t('user.loginPasswordFormat')}
                            error={inputErrors && inputErrors.password ? true : false}
                            InputLabelProps={{ shrink: true }}
                            value={state?.password}
                        />
                    </div>
                    
                    <div>
                        <p className='cl-label fs-14'>{t('user.confirmPassword')}</p>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name='passwordConfirmation'
                            onChange={handleChange}
                            type={option?.passwordConfirmationShow ? 'text' : 'password'}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiLock className="img-style fs-18" />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => handlePasswordShow('passwordConfirmationShow')}>
                                            {option?.passwordConfirmationShow ? <FiEye className="img-style" style={{ color: theme.palette.inputIconColor }} /> : <FiEyeOff className="img-style" style={{ color: theme.palette.inputIconColor }} />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                disableUnderline: true
                            }}
                            helperText={inputErrors && inputErrors.confirm_password ? inputErrors.confirm_password : ''}
                            error={inputErrors && inputErrors.confirm_password ? true : false}
                            InputLabelProps={{ shrink: true }}
                            value={state?.passwordConfirmation}
                        />
                    </div>
                    <div>
                        <p className='cl-label fs-14'>{t('user.securityPassword')}</p>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name='securityPassword'
                            onChange={handleChange}
                            type={option?.securityPasswordShow ? 'text' : 'password'}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiLock className="img-style fs-18" />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => handlePasswordShow('securityPasswordShow')}>
                                            {option?.securityPasswordShow ? <FiEye className="img-style" style={{ color: theme.palette.inputIconColor }} /> : <FiEyeOff className="img-style" style={{ color: theme.palette.inputIconColor }} />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                disableUnderline: true
                            }}
                            helperText={inputErrors && inputErrors.security_password ? inputErrors.security_password : t('user.securityPasswordFormat')}
                            error={inputErrors && inputErrors.security_password ? true : false}
                            InputLabelProps={{ shrink: true }}
                            value={state?.securityPassword}
                        />
                    </div>
                    <div>
                        <p className='cl-label fs-14'>{t('user.securityPasswordConfirm')}</p>
                        <TextField
                            variant="outlined"
                            fullWidth
                            name='securityPasswordConfirmation'
                            onChange={handleChange}
                            type={option?.securityPasswordConfirmationShow ? 'text' : 'password'}
                            InputProps={{
                                startAdornment: (
                                    <InputAdornment position="start">
                                        <FiLock className="img-style fs-18" />
                                    </InputAdornment>
                                ),
                                endAdornment: (
                                    <InputAdornment position="end">
                                        <IconButton onClick={() => handlePasswordShow('securityPasswordConfirmationShow')}>
                                            {option?.securityPasswordConfirmationShow ? <FiEye className="img-style" style={{ color: theme.palette.inputIconColor }} /> : <FiEyeOff className="img-style" style={{ color: theme.palette.inputIconColor }} />}
                                        </IconButton>
                                    </InputAdornment>
                                ),
                                disableUnderline: true
                            }}
                            helperText={inputErrors && inputErrors.security_password_confirmation ? inputErrors.security_password_confirmation : ''}
                            error={inputErrors && inputErrors.security_password_confirmation ? true : false}
                            InputLabelProps={{ shrink: true }}
                            value={state?.securityPasswordConfirmation}
                        />
                    </div>
                </div>
                <div>
                    <div className='p-t-20'>
                        <Button type="button" variant="contained" className='translateY' onClick={handleSubmit} fullWidth >{t('button.submit')}</Button>
                    </div>
                    <div className='p-t-20 txt-center'>
                        <Typography onClick={handleBack} className='pointer translateY'>{t('button.backStep')}</Typography>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <>
            <form style={{ overflowY: 'hidden', marginBottom: 30}}>
                {activeStep === 0 ? 
                    stepOne()
                : 
                    stepTwo()
                }
            </form>

        </>
    )
};